<template>
  <div class="d-flex flex-column align-items-center app-ground">
    <div class="col-12 vue-container">
      <router-view/>
    </div>
  </div>
</template>

<script>
import {setBrandConfig} from "@/functions/setBrandConfig";
import {mapState} from "vuex";
import addGTM from "@/functions/addGTM";

export default {
  computed: {
    ...mapState(['brandConfig'])
  },
  async beforeMount() {
    setBrandConfig();
    this.setTabName()
    this.setFavicon()
    if (this.brandConfig.gtmIdentifier) addGTM(this.brandConfig.gtmIdentifier);
  },
  methods: {
    setTabName() {
      document.title = this.brandConfig.tabTitle;
    },
    setFavicon() {
      this.$nextTick(() => {
        const assetBrand = this.brandConfig.assetBrand || this.brandConfig.brand;
        const faviconPath = require(`@/brand/${assetBrand}/assets/logo.png`);

        const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
        link.rel = 'icon';
        link.type = 'image/png';
        link.href = faviconPath;

        if (!link.parentNode) {
          document.head.appendChild(link);
        }
      });
    },
  }
}
</script>

<style>
.app-ground {
  background-color: #040404;
  min-height: 100vh;
}

/* The design is a 375px mobile artboard and every measurement in the views is an
   absolute px value inside that frame, so the strip is capped rather than being
   allowed to grow through Bootstrap's column ladder. */
.vue-container {
  width: 100%;
  max-width: 375px;
  margin: 0 auto;
  position: relative;
}
</style>
